import React, { useEffect, useState } from 'react'
import { INFDetailFormatted } from '../../../components/NFTDetail/INFTDetail'
import { ICryptoSeals } from '../ICryptoSeals'
import Api from '../../../../../services/Api'
import CryptoSealImage from '../components/CryptoSealImage'
import INFTProperties, { IBaseNFTAttributes } from '../../../models/INFTProperties'
import BaseDetail from '../../Base/Detail/BaseDetail'
import { CryptoSealsCharacterList } from '../CryptoSealsCharacterList'

export default function CryptoSealDetail(props: INFDetailFormatted) {
  const { tokenItem, collection } = props
  const [detailTokenItem, setDetailTokenItem] = useState<ICryptoSeals | null>(null)
  const [tokenUriControl, setTokenUriControl] = useState<boolean>(false)

  useEffect(() => {
    if (tokenItem && tokenItem.tokenId !== undefined && tokenItem.tokenUri && !tokenUriControl) {
      setTokenUriControl(true)
      Api.get(tokenItem.tokenUri).then((tokenResult: any) => setDetailTokenItem(tokenResult))
    }
  }, [tokenItem, tokenUriControl])

  const tokenName = `${collection?.name} #${detailTokenItem ? detailTokenItem.token_id : 0}`

  function getNFTDescription() {
    return (
      <div>
        SO, WHAT IS A CRYPTO SEAL?
        <p>
          A CRYPTOSEAL IS AN ERC721 NON FUNGIBLE TOKEN. THERE WILL BE ONLY 9999 SEALS AVAILABLE. EACH SEAL IS GENERATED
          BY COMPUTER AND HAS IT'S OWN PROPERTIES. SEALS AND PROPERTIES ARE STORED ON IPFS + ARWEAVE. SEALS HAVE
          DIFFERENT TYPES AND EACH ONE OF THEM REPRESENTS A CHARACTER WITH HIDDEN PROPERTIES UNTIL YOU INVOKE THE SEAL.
          EACH CHARACTER HAS 3 DIFFERENT RARITY LEVELS THAT YOU CAN'T SEE IF A SEAL IS NOT INVOKED. SO YOU CAN CHOOSE IF
          YOU WANT TO SUMMON YOUR CREATURE OR KEEP IT FOR FUTURE (YOU CAN'T KNOW WHAT'S INSIDE OF IT!). WHEN YOU INVOKE
          A SEAL, THE CREATURE YOUR SEAL REPRESENTS WILL BE SUMMONED AND VISIBLE, OTHERWISE CREATURE PROPERTIES WILL BE
          HIDDEN AND NOT SHOWN.
        </p>
      </div>
    )
  }

  function getNFTProperties() {
    let result: INFTProperties[] = []

    if (detailTokenItem && detailTokenItem.attributes) {
      result = detailTokenItem.attributes.map((item: IBaseNFTAttributes) => {
        let newProps = {
          key: item.trait_type,
          value: item.value,
          show: true,
          isUrl: false
        }

        if (item.trait_type === 'Character') {
          newProps = {
            ...newProps,
            value: CryptoSealsCharacterList[item.value]
          }
        }

        return newProps
      })
    }

    return result
  }

  return (
    <BaseDetail {...props} tokenItemName={tokenName} description={getNFTDescription()} properites={getNFTProperties()}>
      <CryptoSealImage tokenName={tokenName} tokenItem={detailTokenItem} />
    </BaseDetail>
  )
}
